import { render } from "./VocabularyCard.vue?vue&type=template&id=7da392ce&scoped=true"
import script from "./VocabularyCard.vue?vue&type=script&lang=js"
export * from "./VocabularyCard.vue?vue&type=script&lang=js"

import "./VocabularyCard.vue?vue&type=style&index=0&id=7da392ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7da392ce"]])

export default __exports__